<script setup lang="ts">
import TextTooltip from '@/components/TextTooltip.vue'
import { globalTooltip } from './state'

const { showTooltip, hoveredTooltipText, tooltipX, tooltipY } = globalTooltip
</script>

<template>
  <!-- v-text-tooltip 디렉티브가 공유하는 툴팁. 실험노트 다이얼로그(z-index 999999) 위에도 보이도록 z-index를 높게 둔다. -->
  <TextTooltip
    :show="showTooltip"
    :text="hoveredTooltipText"
    :x="tooltipX"
    :y="tooltipY"
    :z-index="1000001"
  />
</template>
